import React from 'react';
import { Button } from '../ui/button';
import { Phone } from 'lucide-react';

const HomeParallax = ({ onBookCall }) => (
  <section
    className="relative h-[600px] md:h-[700px] bg-fixed bg-center bg-cover overflow-hidden"
    style={{
      backgroundImage:
        'url(https://images.unsplash.com/photo-1656361078320-0a131545ef32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHx3aW5lcnklMjB2aW5leWFyZCUyMHdpbmUlMjBnbGFzc2VzJTIwc3Vuc2V0fGVufDB8fHx8MTc3NTY4ODE5OXww&ixlib=rb-4.1.0&q=85)',
      backgroundAttachment: 'fixed',
    }}
  >
    <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" />
    <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="text-center text-white max-w-4xl animate-fade-in-up">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Craft Your Perfect Wine Experience
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl mb-10 opacity-95 leading-relaxed max-w-2xl mx-auto">
          From grape to glass, experience the art of winemaking with expert guidance and premium quality kits
        </p>
        <Button
          size="lg"
          onClick={onBookCall}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-bold text-lg px-10 py-7 transform hover:scale-105 transition-all duration-300 shadow-2xl"
        >
          <Phone className="w-6 h-6 mr-2" />
          Start Your Wine Journey
        </Button>
      </div>
    </div>
  </section>
);

export default HomeParallax;
